import React from 'react';
import { Form } from 'antd';
import type { FormInstance } from 'antd';
import { FormConfigurationField } from './configs/types';
import { DarwinFlex } from 'components/darwin-ui';

interface FormConfigurationProps {
  fields: FormConfigurationField[];
  renderInput: (field: FormConfigurationField) => JSX.Element;
}

export const ConfigurationFormFields = ({
  fields,
  renderInput,
}: FormConfigurationProps) =>
  fields.map(field => (
    <Form.Item
      key={field.name}
      label={field.label}
      name={field.name}
      style={field.style}
    >
      {renderInput(field)}
    </Form.Item>
  ));

interface ConfigurationFormProps<T = Record<string, unknown>> {
  form: FormInstance;
  initialValues: T;
  fields: FormConfigurationField[];
  renderInput: (field: FormConfigurationField) => JSX.Element;
  className: string;
  onFinish?: (values: T, saveAndExit?: boolean) => void | Promise<void>;
  children?: React.ReactNode;
}

export const ConfigurationForm = <T = Record<string, unknown>,>({
  form,
  initialValues,
  fields,
  renderInput,
  className,
  onFinish,
  children,
}: ConfigurationFormProps<T>) => {
  return (
    <DarwinFlex vertical>
      <Form
        className={className}
        form={form}
        layout="vertical"
        initialValues={initialValues as Record<string, unknown>}
        onFinish={values => onFinish?.(values as T)}
      >
        <ConfigurationFormFields fields={fields} renderInput={renderInput} />
      </Form>
      {children}
    </DarwinFlex>
  );
};
